import { reduxForm } from 'redux-form';
import Component from './SearchRegistrationIdSubUserForm.jsx';
import validate from './validate';

const initialValues = {
  registrationId: '',
};

const SearchRegistrationIdSubUserForm = reduxForm({
  form: 'searchRegistrationIdSubUserForm',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default SearchRegistrationIdSubUserForm;
